import { Box, Center, Flex } from '@mantine/core';
import { Navigate } from 'react-router-dom';

import { AuthHeader } from '@/components/layout';
import { LoginForm } from '@/features/auth/components/LoginForm';
import { LoginHero } from '@/features/auth/components/LoginHero';
import { useAuthContext } from '@/features/auth/context/AuthContext';

export const LoginPage = () => {
  const { isAuthenticated } = useAuthContext();

  // Već prijavljen korisnik ne treba vidjeti login formu — ProtectedRoute
  // dalje odlučuje treba li ga poslati na change-password ili ravno na dashboard.
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <Box mih="100dvh" style={{ backgroundColor: 'var(--color-bg-canvas)' }}>
      <AuthHeader />
      <Center px={{ base: 16, md: 24 }} pt={{ base: 16, md: 64 }} pb={{ base: 32, md: 64 }}>
        <Flex
          direction={{ base: 'column', md: 'row' }}
          gap={{ base: 24, md: 56 }}
          align="stretch"
          w={{ base: '100%', md: 'auto' }}
        >
          <LoginHero />
          <LoginForm />
        </Flex>
      </Center>
    </Box>
  );
};
